import {isNullOrUndefinedObject} from "../utils/validators/Validator";

// Quality check - https://freetools.seobility.net/en/serp-snippet-generator/?url=https://www.bicyclecompany.in/&platform=desktop
export function SetDocumentTitle(title, metaDesc) {
    window.document.title = "Bicycle Company | Pixie Mart - " + title;
    if(!isNullOrUndefinedObject(metaDesc)) {
        document.querySelector('meta[name="description"]').setAttribute("content", metaDesc);
    }
}